import {
  AggregateControlAction,
  Dataset,
  DatasetControl,
  JSONObject,
} from '../../../types/types';
import { getSortParamArray } from '../../../utils/apiRequests/getSortParamArray';
import { DatasetControlAggregateActionApiRequestData } from '../../types/types';

export const getDatasetControlAggregateActionApiRequestData = (
  dataset: Dataset,
  control: DatasetControl,
  token: string | null,
  activeSorting: { field: string; order: number }[],
  filters?: Record<string, any>,
  indexes?: number[],
  master?: { id: string; idItem: string },
  cachedQueryId?: string | null,
  datasetControl?: JSONObject
): DatasetControlAggregateActionApiRequestData => ({
  datasetId: dataset.datasetId || '',
  sessionId: token || '',
  // Set only when actually held — null/omitted drops the x-cachedquery-id header
  ...(cachedQueryId !== undefined ? { cachedQueryId } : {}),
  items: (control.action as AggregateControlAction).items,
  sort: getSortParamArray(activeSorting),
  ...(filters && Object.keys(filters).length > 0 ? { filters } : {}),
  ...(indexes && indexes.length > 0 ? { indexes } : {}),
  ...(master ? { master } : {}),
  ...(datasetControl ? { datasetControl } : {}),
});
